<template>
  <!-- ケアオーケストレーター施設管理 -->
  <div id="COSettingHospitalInternal">
    <div id="container-center">
      <coSettingNavi :pageid='"COSettingHospitalInternal"' :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' :certificationFlag='this.certificationFlag' :searchConditions='this.searchConditions'></coSettingNavi>
      <settingHospital :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' />
      <div style="margin-top:10px;">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/philips/careorchestrator/setting/HospitalContents";

export default {
  name: "COSettingHospitalInternal",
  methods: {
    back: function() {
      this.$router.push({ name: "COUploadCertificate" , params: { searchConditions: this.searchConditions }});
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    let searchConditions = this.$route.params["searchConditions"]
    return {
      careOrchestratorInstitutionId : careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions, searchConditions
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingHospital: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/COSettingHospital.vue